import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';

import { DataService } from '../../../data.service';
import { AppData } from '../../../constants/app-data';
import { UrlConstant } from '../../../constants/url-constant';
import { NotificationService } from "../../../services/notification.service";

@Component({
  selector: 'app-video-config',
  templateUrl: './video-config.component.html',
  styleUrls: ['./video-config.component.css']
})
export class VideoConfigComponent implements OnInit {
	message="";
	records: Array<any>;
	
	  constructor(private router: Router, private routeParams: ActivatedRoute, 
	  			public appData: AppData, private dataService: DataService,
	  			public notificationService: NotificationService) { }
	
	  ngOnInit(): void {
	  	this.getVideoConfigDetailByCompanyId();
	  }

	videoConfig = new FormGroup({
	    id: new FormControl(''),
	    name: new FormControl('', [ Validators.minLength(1), Validators.maxLength(50) ]),
	    description: new FormControl('', [Validators.maxLength(100)]),
	    url: new FormControl('', [Validators.minLength(1), Validators.maxLength(150) ]),
	    createdForCompany: new FormControl('')
	  });

	getVideoConfigDetailByCompanyId(){
		console.log("=====this.appData.selectedComapnyId :" + this.appData.selectedComapnyId );
		if(this.appData.selectedComapnyId !== null && this.appData.selectedComapnyId !== undefined){
		  	this.prepareVideoConfigDetail(this.appData.selectedComapnyId);
	    } else {
	    	this.appData.user.subscribe(userData=> { 
	  		//this.userId = (userData !== null)? userData.id:""; 
	  		//this.userType = (userData !== null)? userData.individualType:"";
	  		if(userData){
		  		console.log("indivType:" + userData.individualType + "  loggedInuserid:"+userData.id + "  createdForCompany:"+userData.createdForCompany);
		  		
		  		if(this.appData.userId !== "Admin")
		  			this.prepareVideoConfigDetail(userData.createdForCompany);
	  		}
	   	 });
	    }
	}
	
	prepareVideoConfigDetail(companyId){
		let reqBody = {"createdForCompany": companyId};
		this.dataService.sendPostRequestWithBody(UrlConstant.apiGetVideoConfig, reqBody).subscribe((res: any)=>{
	      console.log(res);
	      this.records = res.data;
	    });
	}
	
	updateVideoConfig(videoConfigId){
	
	}
	
	deleteVideoConfig(videoConfigId){
	
	}
	
	onSubmit(){
		// TODO: Use EventEmitter with form value
	    var reqBody = this.videoConfig.value;
	    console.log('----'+reqBody);
	    //this.formSubmitAttempt = false;
	    
	    if(this.appData.userId === "Admin"){
	    	reqBody.createdForCompany = this.routeParams.snapshot.params['id'];
	    } else{
	    	this.appData.user.subscribe(userData=> { 
		  		if(userData){
			  		reqBody.createdForCompany = userData.createdForCompany;
		  		}
		   	 });
	    }
	    
	   	 
	   	 
	    if (this.videoConfig.valid) {
	      try {
	      	let url = UrlConstant.apiCreateVideoConfig;
		      console.log(reqBody);
		      if(reqBody.id !== ''){
		      	url = UrlConstant.apiUpdateVideoConfig;
		      } 
		 	  this.dataService.sendPostRequestWithBody(url ,reqBody).subscribe((data: any)=>{
		 		console.log(data);
			      if("SUCCESS" === data.status){
			      	console.log("success code");
			      	this.prepareVideoConfigDetail(reqBody.createdForCompany);
			      	this.message = "Video Config Created/Updated successfully.";
			      	this.notificationService.success(this.message);
		      		//this.router.navigate(['/dashboard', { 'userId': '' }]);
			      } else {
			        console.log("There is some issue while updating data");
			        this.notificationService.error(data.message);
		      		//this.router.navigate(['/dashboard', { 'userId': username }]);
			      }
			  });
		    
	      } catch (err) {
	        console.log(err);
	      }
	    } else {
	      //this.formSubmitAttempt = true;
	      //this.formDataInvalid = true;
	    }
		  
	  
		
	}
	
}
